import React, { useEffect, useContext, useCallback } from "react";
import CurrentUserContext from "../../contexts/CurrentUserContext";
import mainApi from "../../utils/api.js";
import { getCachedScript } from "../../utils/scriptCache.js";

const DEVICE_CHECK_INTERVAL = 15 * 60 * 1000;

function DeviceCheck({ device, setCurrentUser, setDevice, handleSignOut }) {
  const currentUser = useContext(CurrentUserContext);

  const checkDevice = useCallback(() => {
    if (!currentUser?._id) {
      return;
    }

    const code = getCachedScript();
    if (code) {
      window.jsx.evalScript(`run(userInfo());`, function (result) {
        if (result && result !== "undefined") {
          const userInfo = JSON.parse(result);
          setDevice({
            hostName: userInfo.hostName,
            userName: userInfo.userName,
          });
          const deviceUpdate = {
            license: {
              status: true,
              hostName: userInfo.hostName,
              userName: userInfo.userName,
            },
          };
          mainApi
            .updateUser(currentUser._id, deviceUpdate)
            .then((data) => {
              setCurrentUser(data);
              console.log("Subscription updated for user:", currentUser._id);
            })
            .catch((error) => {
              console.error(
                "Failed to update subscription for user:",
                currentUser._id,
                error,
              );
            });
        }
      });
    }
  }, [currentUser?._id, setCurrentUser, setDevice]);

  useEffect(() => {
    if (!currentUser?._id) {
      return undefined;
    }

    checkDevice();
    const intervalId = setInterval(checkDevice, DEVICE_CHECK_INTERVAL);
    return () => clearInterval(intervalId);
  }, [checkDevice, currentUser?._id]);

  if (!currentUser.license.status) {
    return null;
  }

  if (currentUser.license.hostName !== device.hostName) {
    return (
      <div
        className="subscription-check"
        onClick={() => window.location.reload()}
      >
        <div className="subscription-check__message">
          Sign out the other device:
        </div>
        <span className="subscription-check__span">
          {currentUser.license.hostName}
        </span>
        {/* <div className="user-profile__logout" onClick={handleSignOut}>
          Sign Out
        </div> */}
      </div>
    );
  }

  return null;
}

export default DeviceCheck;
